import React from "react";
import styled from "styled-components";

/**
 * @brief 상단 배너(image full-size) 스타일드 컴포넌트
 */
export default function MainBanner({ img, children }) {
  return (
    <BannerContainer $img={img}>
      <BannerBox>{children}</BannerBox>
    </BannerContainer>
  );
}

export const BannerContainer = styled.section`
  width: 100%;
  max-width: 430px;
  margin: 0 auto;
  min-height: 320px;
  height: auto;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: ${({ $img }) => `url(${$img})`};
  display: flex;
  align-items: flex-start;
`;

const BannerBox = styled.article`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
  margin: 0 auto;
  align-items: flex-start;
  justify-content: flex-start;
`;
